import { wrap as withStyle } from 'utils/styles'

export default withStyle((props) => {
  const {
    theme: { linkColor, linklinkColorHover },
  } = props

  return `
    color: ${linkColor};
    text-decoration: none;
    cursor: pointer;

    &:hover,
    &:focus,
    &:active {
      text-decoration: underline;
      color: ${linklinkColorHover}
    }
  `
})
